// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1mE3z","inputWrap":"styles_inputWrap__K7rDZ","input":"styles_input__1yZfF"};